import {
  showSuccessSnackbar,
  clearSnackbar,
  showErrorSnackbar,
  showWarningSnackbar,
  showInfoSnackbar,
} from "./actions";
import { Dispatch } from "redux";

export const showSuccess = (message: string) => {
  return (dispatch: Dispatch) => {
    dispatch(showSuccessSnackbar(message));
  };
};

export const clearSnack = () => {
  return (dispatch: Dispatch) => {
    dispatch(clearSnackbar());
  };
};

export const showError = (message: string) => {
  return (dispatch: Dispatch) => {
    dispatch(showErrorSnackbar(message));
  };
};

export const showWarning = (message: string) => {
  return (dispatch: Dispatch) => {
    dispatch(showWarningSnackbar(message));
  };
};

export const showInfo = (message: string) => {
  return (dispatch: Dispatch) => {
    dispatch(showInfoSnackbar(message));
  };
};
